export const HOME_PATH = "/";
export const KYC_PATH = "/kyc";
export const VIRTUAL_ASSETS_PATH = "/virtual-assets";
export const SELF_CERTIFICATION_PATH = "/self-certification";
export const CERTIFICATION_PATH = "/certification";
export const EDD_PATH = "/edd";
export const ACCOUNT_TYPE_PATH = "/account-type";
export const UK_REGULATIONS = "/uk-regulations";
